export default __webpack_public_path__ + "static/media/RD-1.ad26b05c.jpg";